<template lang="pug">
#app
  #navbar-router-wrapper
    app-navbar
    router-view
  app-footer
  
  toasts
</template>

<script>
import Navbar from '@/components/layout/Navbar.vue'
import Footer from '@/components/layout/Footer.vue'
import Vue from 'vue';
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import Toasts from '@/components/shared/toasts.vue'
import { mapActions } from 'vuex'

Vue.use(VuejsDialog);

export default {
  components: {
    'app-navbar': Navbar,
    'app-footer': Footer,
    Toasts
  },

  created() {
    this.FETCH_CURRENT_USER_REQUEST()
  },

  methods: mapActions(['FETCH_CURRENT_USER_REQUEST'])
}
</script>

<style lang="scss">
  @import "@/assets/css/style.scss";
</style>
